import { useState, useEffect } from 'react';
import RecordVideo from '../../RecordVideo/RecordVideo';
import { CustomButton } from 'shared_ui_components';
import VideoPlayer from '../../Common/VideoPlayer';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';

const RealPlayRecorder = ({ isPublic = false, aiProspectOption = false }) => {
  const [wantsToRecord, setWantsToRecord] = useState(false);
  const { scenario_uuid, videoURL, setTempVideoUrl, setSessionInfoTemp } =
    RealPlayRecordDataHelper();

  const onCancel = () => {
    setWantsToRecord(false);
    setSessionInfoTemp({});
    setTempVideoUrl('');
  };
  const onStart = () => setWantsToRecord(true);

  useEffect(() => {
    setWantsToRecord(false);
  }, [scenario_uuid]);

  if (wantsToRecord)
    return (
      <RecordVideo
        onCancelRecord={onCancel}
        onStartRecord={onStart}
        isPublic={isPublic}
        aiProspectOption={aiProspectOption}
      />
    );

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        borderRadius: '4px',
        backgroundColor: videoURL ? null : '#e8ebed',
      }}
    >
      {videoURL ? (
        <VideoPlayer url={videoURL} />
      ) : (
        <CustomButton onClick={onStart} className="primaryBtn">
          Record video max 5 min
        </CustomButton>
      )}
    </div>
  );
};

export default RealPlayRecorder;
